<script lang="ts">
    import { push } from "svelte-spa-router";
    import { onMount } from "svelte";
    import { me } from "@frontend/user";
    
    // svelte-ignore unused-export-let
    export let params: any = {};

    onMount(() => {
        if (!$me) {
            push("/user/Login");
        }
    });
</script>